import styled, { keyframes } from 'styled-components';

import { colors } from 'styles/colors';

const textMain = colors.text['main-900'];
const textSub = colors.text['sub-500'];
const primaryLight = colors.brand.primary.lighter;

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const barPulse = keyframes`
  0%   { width: 8%;  opacity: 0.7; }
  45%  { width: 72%; opacity: 1;   }
  100% { width: 8%;  opacity: 0.7; }
`;

const stepBlink = keyframes`
  0%, 100% { opacity: 1;    }
  50%       { opacity: 0.35; }
`;

export const ProgressWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ProgressTop = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;

  @media (min-width: 768px) {
    flex-wrap: nowrap;
    gap: 16px;
  }
`;

export const Spinner = styled.div`
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border: 3px solid ${primaryLight};
  border-top-color: ${colors.Blue300};
  border-radius: 50%;
  animation: ${spin} 0.9s linear infinite;
`;

export const ProgressInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ProgressInfoTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${textMain};
  margin-bottom: 2px;
`;

export const ProgressInfoSub = styled.div`
  font-size: 12px;
  color: ${textSub};
`;

export const DeadlineBadge = styled.div`
  flex-shrink: 0;
  background: ${primaryLight};
  color: ${colors.Blue300};
  border-radius: 999px;
  padding: 5px 12px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  flex-basis: 100%;

  @media (min-width: 768px) {
    flex-basis: auto;
    margin-left: auto;
  }
`;

export const ProgressBarWrap = styled.div`
  height: 4px;
  background: ${colors.Grey050};
  border-radius: 999px;
  overflow: hidden;
`;

export const ProgressBarFill = styled.div`
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, ${colors.Blue300} 0%, #1890FF 100%);
  animation: ${barPulse} 2.8s ease-in-out infinite;
`;

export const ProgressSteps = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
`;

export const ProgressStep = styled.div<{ $running?: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: ${({ $running }) => ($running ? colors.Blue300 : colors.Grey300)};
  font-weight: ${({ $running }) => ($running ? 500 : 400)};
  animation: ${({ $running }) => ($running ? stepBlink : 'none')} 1.2s ease-in-out infinite;

  &::before {
    content: '';
    display: block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
    background: ${({ $running }) => ($running ? colors.Blue300 : colors.Grey050)};
  }
`;

export const InstructionsBox = styled.div`
  background: ${colors.Grey030};
  border-radius: 10px;
  padding: 14px 16px;
`;

export const InstructionsTitle = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${textMain};
  margin-bottom: 8px;
`;

export const ProgressActions = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const InstructionItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 12px;
  color: ${textSub};
  line-height: 1.55;

  &::before {
    content: '';
    display: block;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: ${colors.Blue300};
    flex-shrink: 0;
    margin-top: 5px;
  }
`;
